function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 4C0 1.79086 1.79086 0 4 0H16C18.2091 0 20 1.79086 20 4V16C20 18.2091 18.2091 20 16 20H4C1.79086 20 0 18.2091 0 16V4Z",
  fill: "#B8E1F6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.5625 4.5C7.86719 4.5 8.125 4.75781 8.125 5.0625V6H11.875V5.0625C11.875 4.75781 12.1328 4.5 12.4375 4.5C12.7422 4.5 13 4.75781 13 5.0625V6H13.75C14.5703 6 15.25 6.67969 15.25 7.5V14.25C15.25 15.0703 14.5703 15.75 13.75 15.75H6.25C5.42969 15.75 4.75 15.0703 4.75 14.25V7.5C4.75 6.67969 5.42969 6 6.25 6H7V5.0625C7 4.75781 7.25781 4.5 7.5625 4.5ZM7.5625 7.125H6.25C6.03906 7.125 5.875 7.28906 5.875 7.5V8.625H14.125V7.5C14.125 7.28906 13.9609 7.125 13.75 7.125H7.5625ZM5.875 9.75V14.25C5.875 14.4609 6.03906 14.625 6.25 14.625H13.75C13.9609 14.625 14.125 14.4609 14.125 14.25V9.75H5.875Z",
  fill: "#006CA3"
});

function SvgCreatedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatedIcon);
export default __webpack_public_path__ + "static/media/created-icon.bb987c76.svg";
export { ForwardRef as ReactComponent };